<template>
  <section class="ine-form">
    <div class="ine-form__background">
      <img class="ine-form__logo" src="@/assets/images/home-logo.png" />
    </div>
    <div class="ine-form__form-wrapper">
      <form class="ine-form__form" @submit.prevent="validateForm">
        <div class="ine-form__title-wrapper">
          <h4 class="ine-form__welcome">Welcome Back,</h4>
          <p class="ine-form__lead-in">Log in to your account</p>
        </div>
        <div class="ine-form__form-group">
          <input
            type="email"
            class="ine-form__form-control"
            placeholder="email"
            id="email"
            v-model="email"
          />
        </div>
        <div class="ine-form__form-group">
          <input
            type="password"
            class="ine-form__form-control"
            placeholder="password"
            id="password"
            v-model="password"
          />
        </div>
        <div class="ine-form__submit-btn-wrapper">
          <div v-show="!loading" class="ine-form__auth-options">
            <button
              class="btn__auth ine-form__submit-btn"
              type="submit"
              v-show="!loading"
            >
              Log In
              <span class="material-icons btn__auth--icon">person</span>
            </button>
            <button
              v-show="!isCordova"
              v-for="provider in authProviders"
              :key="`provider-${provider.id}`"
              class="btn__auth"
              :style="`background: #${provider.color}`"
              @click.prevent="loginThroughProvider(provider)"
            >
              Log In with {{ provider.name }}
              <img :src="provider.icon" class="btn__auth--icon" />
            </button>
          </div>
          <ClipLoader
            v-show="loading"
            :size="1.5"
            sizeUnit="rem"
            class="ine-form__loading-spinner"
          ></ClipLoader>
        </div>
        <div class="ine-form__additional-links-wrapper">
          <a
            v-if="!isCordova"
            :href="
              `https://${membersUrl}/user/signup?redirect_url=${redirectUrlPostConfirm}`
            "
            class="ine-form__additional-link"
          >
            New Account
          </a>
          <a
            v-if="!isCordova"
            :href="`https://${membersUrl}/auth/forgot`"
            class="ine-form__additional-link"
          >
            Forgot Password
          </a>
          <a
            v-if="!isCordova"
            class="ine-form__additional-link"
            target="_blank"
            href="https://ine.com/pages/all-access-pass"
            >Learn More About Our Plans</a
          >
        </div>
        <div class="ine-form__additional-links-wrapper ine-form__homepage-link">
          <router-link class="ine-form__additional-link" :to="{ name: 'home' }"
            >Back to Homepage</router-link
          >
        </div>
      </form>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { ClipLoader } from '@saeris/vue-spinners'

export default {
  name: 'Login',
  components: {
    ClipLoader,
  },
  data() {
    return {
      email: '',
      password: '',
      loading: false,
      from: null,
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.from = from
    })
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      isTwoFactorRequired: 'auth/isTwoFactorRequired',
      searchQuery: 'search/searchQuery',
      memberId: 'auth/memberId',
      userId: 'auth/userId',
      authProviders: 'auth/authProviders',
      isCordova: 'app/isCordova',
      redirectUrl: 'auth/redirectUrl',
    }),
    membersUrl() {
      return process.env.VUE_APP_MEMBERS_URL
    },
    redirectUrlPostConfirm() {
      return process.env.VUE_APP_POST_CONFIRMATION_REDIRECT
    },
  },
  methods: {
    emailTest(value) {
      // const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      // return pattern.test(value)
      return value.length >= 1
    },
    passwordTest(value) {
      return value.length >= 1
    },
    validateForm() {
      if (!this.emailTest(this.email)) {
        this.$store.dispatch('app/setError', 'Please Enter A Valid Email.')
      } else if (!this.passwordTest(this.password)) {
        this.$store.dispatch('app/setError', 'Please Enter A Password.')
      } else {
        this.loading = true
        this.onSubmit()
      }
    },
    async onSubmit() {
      const authData = {
        email: this.email,
        password: this.password,
      }
      await this.$store.dispatch('auth/login', authData)
      if (this.isTwoFactorRequired) {
        this.$router.push({ name: 'two-factor' })
        return
      }
      if (this.isAuthenticated) {
        window.dataLayer.push({
          event: 'start_pw',
          pw_user_email: this.email,
        })
        if (!this.redirectUrl) {
          this.getNextRoute()
        } else {
          window.location.assign(this.redirectUrl)
        }
      } else {
        this.loading = false
      }
    },
    loginThroughProvider(provider) {
      this.loading = true
      const { url } = provider
      window.open(url, '_parent')
    },
    getNextRoute() {
      if (this.from && this.from.name) {
        switch (this.from.name) {
          case 'forget':
            this.$router.push({ name: 'home' })
            break
          case 'home':
            this.$router.push({ name: 'home' })
            break
          case 'search':
            this.$router.push({ name: 'search' })
            break
          case 'error':
            this.$router.push({ name: 'home' })
            break
          default:
            if (this.from.fullPath) {
              this.$router.push(this.from.fullPath)
            } else {
              this.$router.push({ name: 'home' })
            }
        }
      } else {
        this.$router.push({ name: 'home' })
      }
    },
    checkForParams() {
      const currentUrl = window.location.href
      this.handleRedirect(currentUrl)
      this.handleErrorParam(currentUrl)
    },
    handleRedirect(currentUrl) {
      const redirectUrl = decodeURIComponent(currentUrl).split(
        'redirect_url='
      )[1]
      if (redirectUrl && redirectUrl.length) {
        if (redirectUrl.includes('&')) {
          this.$store.dispatch('auth/setRedirectUrl', redirectUrl.split('&')[0])
        } else {
          this.$store.dispatch('auth/setRedirectUrl', redirectUrl)
        }
      }
    },
    handleErrorParam(currentUrl) {
      const { error } = this.$route.params
      if (error && error.length) {
        this.$toasted.global.appNotification({
          message: error,
        })
      }
      const errorParam = decodeURIComponent(currentUrl).split('error=')[1]
      if (errorParam && errorParam.length) {
        if (errorParam.includes('&')) {
          this.$toasted.global.appNotification({
            message: errorParam.split('&')[0],
          })
        } else {
          this.$toasted.global.appNotification({
            message: errorParam,
          })
        }
      }
    },
  },
  async created() {
    this.$store.dispatch('app/setIsPageLoading', true)
    if (this.isTwoFactorRequired) {
      this.$router.push({ name: 'two-factor' })
      return
    }
    this.$store.dispatch('auth/setRedirectUrl', '')
    this.checkForParams()
    await this.$store.dispatch('auth/getAuthProviders')
    this.$store.dispatch('app/setIsPageLoading', false)
  },
}
</script>
